export enum MODULES {
  NOTIFICATIONS = "notifications",
  WARRANTIES = "warranties",
  ROLES = "roles",
  VEHICLES = "vehicles",
  METER_ENTRIES = "meter_entries",
  FUEL_ENTRIES = "fuel_entries",
  ISSUES = "issues",
  FAULTS = "faults",
  FAULTS_RULES = "faults_rules",
  TELEMATICS_DEVICES = "telematics_devices",
  RECALLS = "recalls",
  SERVICE_TASK_MANAGEMENT = "service_task_management",
  SERVICE_ENTRIES = "service_entries",
  WORK_ORDERS = "work_orders",
  INSPECTIONS = "inspections",
  VEHICLE_SERVICE_REMINDERS = "vehicle_service_reminders",
  CONTACT_RENEWAL_REMINDERS = "contact_renewal_reminders",
  VEHICLE_RENEWAL_REMINDERS = "vehicle_renewal_reminders",
  CONTACTS = "contacts",
  VENDORS = "vendors",
  INVENTORY = "inventory",
  PURCHASE_ORDERS = "purchase_orders",
  REPORTS = "reports",
  LOCATION_ENTRIES = "location_entries",
  EXPENSE_ENTRIES = "expense_entries",
  DASHBOARDS = "dashboards",
  DOCUMENTS = "documents",
  INTEGRATIONS = "integrations",
  EQUIPMENTS = "equipments",
  SCHEDULES = "inspections",
}

export enum PERMISSIONS {
  FULL_NOTIFICATIONS_ACCESS = "full_notifications_access",
  VIEW_NOTIFICATIONS = "view_notifications",
  FULL_WARRANTIES_ACCESS = "full_warranties_access",
  VIEW_WARRANTIES = "view_warranties",
  MANAGE_WARRANTIES = "manage_warranties",
  FULL_ROLES_ACCESS = "full_roles_access",
  FULL_SCHEDULES_ACCESS = "full_inspections_access",
  VIEW_SCHEDULES = "view_inspection_schedules",
  MANAGE_ROLES = "manage_roles",
  VIEW_ROLES = "view_roles",
  CREATE_ROLES = "create_roles",
  EDIT_ROLES = "edit_roles",
  DELETE_ROLES = "delete_roles",
  VIEW_VEHICLE_EXPENSES = "view_vehicle_expenses",
  MANAGE_VEHICLE_EXPENSES = "manage_vehicle_expenses",
  FULL_VEHICLE_ACCESS = "full_vehicle_access",
  CREATE_VEHICLE = "create_vehicle",
  EDIT_VEHICLE = "edit_vehicle",
  VIEW_VEHICLE = "view_vehicle",
  VIEW_VEHICLE_SPECS = "view_vehicle_specs",
  VIEW_VEHICLE_FILES = "view_vehicle_files",
  VIEW_FINANCIAL_INFO = "view_financial_info",
  EXPORT_VEHICLE_DATA = "export_vehicle_data",
  VIEW_DELETED_VEHICLES = "view_deleted_vehicles",
  ARCHIVE_DELETE_VEHICLE = "archive_delete_vehicle",
  VIEW_VEHICLE_ATTACHMENTS = "view_vehicle_attachments",
  MANAGE_VEHICLE_ATTACHMENTS = "manage_vehicle_attachments",
  VIEW_VEHICLE_ASSIGNMENTS = "view_vehicle_assignments",
  MANAGE_VEHICLE_ASSIGNMENTS = "manage_vehicle_assignments",
  FULL_METER_ENTRIES_ACCESS = "full_meter_entries_access",
  CREATE_METER_ENTRIES = "create_meter_entries",
  EDIT_METER_ENTRIES = "edit_meter_entries",
  VIEW_METER_ENTRIES = "view_meter_entries",
  EXPORT_METER_DATA = "export_meter_data",
  DELETE_METER_ENTRIES = "delete_meter_entries",
  VIEW_METER_ENTRY_ATTACHMENTS = "view_meter_entry_attachments",
  MANAGE_METER_ENTRY_ATTACHMENTS = "manage_meter_entry_attachments",
  FULL_FUEL_ENTRIES_ACCESS = "full_fuel_entries_access",
  EDIT_FUEL_ENTRIES = "edit_fuel_entries",
  VIEW_FUEL_ENTRIES = "view_fuel_entries",
  EXPORT_FUEL_ENTRIES_DATA = "export_fuel_entries_data",
  DELETE_FUEL_ENTRIES = "delete_fuel_entries",
  VIEW_FUEL_ENTRY_ATTACHMENTS = "view_fuel_entry_attachments",
  MANAGE_FUEL_ENTRY_ATTACHMENTS = "manage_fuel_entry_attachments",
  CREATE_FUEL_ENTRIES = "create_fuel_entries",
  VIEW_ISSUES = "view_issues",
  EXPORT_ISSUES_DATA = "export_issues_data",
  DELETE_ISSUES = "delete_issues",
  VIEW_ISSUE_ATTACHMENTS = "view_issue_attachments",
  MANAGE_ISSUE_ATTACHMENTS = "manage_issue_attachments",
  FULL_ISSUES_ACCESS = "full_issues_access",
  CREATE_ISSUES = "create_issues",
  EDIT_ISSUES = "edit_issues",
  FULL_FAULTS_ACCESS = "full_faults_access",
  IGNORE_FAULT_CODES = "ignore_fault_codes",
  FULL_FAULTS_RULES_ACCESS = "full_faults_rules_access",
  VIEW_FAULTS_RULES = "view_faults_rules",
  VIEW_FAULTS_RULES_DETAILS = "view_faults_rules_details",
  EXPORT_FAULTS_RULES_DATA = "export_faults_rules_data",
  CREATE_FAULTS_RULES = "create_faults_rules",
  EDIT_FAULTS_RULES = "edit_faults_rules",
  DELETE_FAULTS_RULES = "delete_faults_rules",
  FULL_TELEMATICS_DEVICES_ACCESS = "full_telematics_devices_access",
  VIEW_TELEMATICS_DEVICES = "view_telematics_devices",
  VIEW_TELEMATICS_DEVICES_DETAILS = "view_telematics_devices_details",
  EXPORT_TELEMATICS_DEVICES_DATA = "export_telematics_devices_data",
  ASSIGN_TELEMATICS_DEVICES = "assign_telematics_devices",
  UNASSIGN_TELEMATICS_DEVICES = "unassign_telematics_devices",
  ARCHIVE_TELEMATICS_DEVICES = "archive_telematics_devices",
  CREATE_TELEMATICS_DEVICES = "create_telematics_devices",
  EDIT_TELEMATICS_DEVICES = "edit_telematics_devices",
  DELETE_TELEMATICS_DEVICES = "delete_telematics_devices",
  FULL_RECALLS_ACCESS = "full_recalls_access",
  ACKNOWLEDGE_RECALLS = "acknowledge_recalls",
  FULL_SERVICE_TASK_MANAGEMENT_ACCESS = "full_service_task_management_access",
  VIEW_SERVICE_TASKS = "view_service_tasks",
  VIEW_SERVICE_TASKS_DETAILS = "view_service_tasks_details",
  EXPORT_SERVICE_TASKS_DATA = "export_service_tasks_data",
  VIEW_MAINTENANCE_CATEGORY = "view_maintenance_category",
  VIEW_SYSTEM_CODE = "view_system_code",
  VIEW_ASSEMBLY_CODE = "view_assembly_code",
  VIEW_REASON_FOR_REPAIR_CODE = "view_reason_for_repair_code",
  CREATE_SERVICE_TASKS = "create_service_tasks",
  EDIT_SERVICE_TASKS = "edit_service_tasks",
  ARCHIVE_DELETE_SERVICE_TASKS = "archive_delete_service_tasks",
  VIEW_SERVICE_TASK_ATTACHMENTS = "view_service_task_attachments",
  MANAGE_SERVICE_TASK_ATTACHMENTS = "manage_service_task_attachments",
  CREATE_SERVICE_ENTRIES = "create_service_entries",
  EDIT_SERVICE_ENTRIES = "edit_service_entries",
  VIEW_SERVICE_ENTRIES = "view_service_entries",
  VIEW_UPDATE_COST_INFORMATION = "view_update_cost_information",
  EXPORT_SERVICE_ENTRIES_DATA = "export_service_entries_data",
  DELETE_SERVICE_ENTRIES = "delete_service_entries",
  VIEW_SERVICE_ENTRY_ATTACHMENTS = "view_service_entry_attachments",
  MANAGE_SERVICE_ENTRY_ATTACHMENTS = "manage_service_entry_attachments",
  FULL_SERVICE_ENTRIES_ACCESS = "full_service_entries_access",
  FULL_WORK_ORDERS_ACCESS = "full_work_orders_access",
  CREATE_WORK_ORDERS = "create_work_orders",
  EDIT_WORK_ORDERS = "edit_work_orders",
  MANAGE_LABOR_WORK_ORDERS = "manage_labor_work_orders",
  VIEW_WORK_ORDERS = "view_work_orders",
  VIEW_UPDATE_COST_INFORMATION_WORK_ORDERS = "view_update_cost_information_work_orders",
  EXPORT_WORK_ORDERS_DATA = "export_work_orders_data",
  VIEW_INCOMPLETE_WORK_ORDERS = "view_incomplete_work_orders",
  VIEW_COMPLETED_WORK_ORDERS = "view_completed_work_orders",
  DELETE_WORK_ORDERS = "delete_work_orders",
  VIEW_WORK_ORDER_ATTACHMENTS = "view_work_order_attachments",
  MANAGE_WORK_ORDER_ATTACHMENTS = "manage_work_order_attachments",
  FULL_INSPECTIONS_ACCESS = "full_inspections_access",
  MANAGE_INSPECTION_FORMS = "manage_inspection_forms",
  CREATE_INSPECTIONS = "create_inspections",
  EDIT_INSPECTIONS = "edit_inspections",
  EDIT_INSPECTION_SUBMISSIONS = "edit_inspection_submissions",
  DELETE_INSPECTION_SUBMISSIONS = "delete_inspection_submissions",
  VIEW_INSPECTIONS = "view_inspections",
  VIEW_SUBMISSIONS_ITEM_FAILURES = "view_submissions_item_failures",
  EXPORT_INSPECTIONS_DATA = "export_inspections_data",
  FULL_VEHICLE_SERVICE_REMINDERS_ACCESS = "full_vehicle_service_reminders_access",
  CREATE_VEHICLE_SERVICE_REMINDERS = "create_vehicle_service_reminders",
  EDIT_VEHICLE_SERVICE_REMINDERS = "edit_vehicle_service_reminders",
  VIEW_VEHICLE_SERVICE_REMINDERS = "view_vehicle_service_reminders",
  EXPORT_VEHICLE_SERVICE_REMINDERS_DATA = "export_vehicle_service_reminders_data",
  DELETE_VEHICLE_SERVICE_REMINDERS = "delete_vehicle_service_reminders",
  VIEW_VEHICLE_SERVICE_REMINDER_ATTACHMENTS = "view_vehicle_service_reminder_attachments",
  MANAGE_VEHICLE_SERVICE_REMINDER_ATTACHMENTS = "manage_vehicle_service_reminder_attachments",
  FULL_CONTACT_RENEWAL_REMINDERS_ACCESS = "full_contact_renewal_reminders_access",
  CREATE_CONTACT_RENEWAL_REMINDERS = "create_contact_renewal_reminders",
  EDIT_CONTACT_RENEWAL_REMINDERS = "edit_contact_renewal_reminders",
  VIEW_CONTACT_RENEWAL_REMINDERS = "view_contact_renewal_reminders",
  EXPORT_CONTACT_RENEWAL_REMINDERS_DATA = "export_contact_renewal_reminders_data",
  DELETE_CONTACT_RENEWAL_REMINDERS = "delete_contact_renewal_reminders",
  VIEW_CONTACT_RENEWAL_REMINDER_ATTACHMENTS = "view_contact_renewal_reminder_attachments",
  MANAGE_CONTACT_RENEWAL_REMINDER_ATTACHMENTS = "manage_contact_renewal_reminder_attachments",
  FULL_VEHICLE_RENEWAL_REMINDERS_ACCESS = "full_vehicle_renewal_reminders_access",
  CREATE_VEHICLE_RENEWAL_REMINDERS = "create_vehicle_renewal_reminders",
  EDIT_VEHICLE_RENEWAL_REMINDERS = "edit_vehicle_renewal_reminders",
  VIEW_VEHICLE_RENEWAL_REMINDERS = "view_vehicle_renewal_reminders",
  EXPORT_VEHICLE_RENEWAL_REMINDERS_DATA = "export_vehicle_renewal_reminders_data",
  DELETE_VEHICLE_RENEWAL_REMINDERS = "delete_vehicle_renewal_reminders",
  VIEW_VEHICLE_RENEWAL_REMINDER_ATTACHMENTS = "view_vehicle_renewal_reminder_attachments",
  MANAGE_VEHICLE_RENEWAL_REMINDER_ATTACHMENTS = "manage_vehicle_renewal_reminder_attachments",
  FULL_CONTACTS_ACCESS = "full_contacts_access",
  EDIT_CONTACTS = "edit_contacts",
  VIEW_CONTACTS = "view_contacts",
  EXPORT_CONTACTS_DATA = "export_contacts_data",
  ARCHIVE_DELETE_CONTACTS = "archive_delete_contacts",
  VIEW_CONTACT_ATTACHMENTS = "view_contact_attachments",
  MANAGE_CONTACT_ATTACHMENTS = "manage_contact_attachments",
  CREATE_CONTACTS = "create_contacts",
  FULL_VENDORS_ACCESS = "full_vendors_access",
  CREATE_VENDORS = "create_vendors",
  EDIT_VENDORS = "edit_vendors",
  VIEW_VENDORS = "view_vendors",
  EXPORT_VENDORS_DATA = "export_vendors_data",
  ARCHIVE_DELETE_VENDORS = "archive_delete_vendors",
  VIEW_VENDOR_ATTACHMENTS = "view_vendor_attachments",
  MANAGE_VENDOR_ATTACHMENTS = "manage_vendor_attachments",
  FULL_PARTS_ACCESS = "full_parts_access",
  EDIT_PARTS = "edit_parts",
  UPDATE_INVENTORY_QUANTITIES = "update_inventory_quantities",
  VIEW_PARTS = "view_parts",
  VIEW_PART_ACTIVITY = "view_part_activity",
  EXPORT_PARTS_DATA = "export_parts_data",
  ARCHIVE_DELETE_PARTS = "archive_delete_parts",
  MANAGE_PART_ATTACHMENTS = "manage_part_attachments",
  CREATE_PARTS = "create_parts",
  FULL_PURCHASE_ORDERS_ACCESS = "full_purchase_orders_access",
  MANAGE_PURCHASE_ORDERS = "manage_purchase_orders",
  FULL_REPORTS_ACCESS = "full_reports_access",
  VIEW_REPORTS = "view_reports",
  VIEW_VEHICLE_REPORTS = "view_vehicle_reports",
  VIEW_CONTACT_REPORTS = "view_contact_reports",
  VIEW_PART_REPORTS = "view_part_reports",
  VIEW_ISSUES_REPORTS = "view_issues_reports",
  VIEW_WORK_ORDER_REPORTS = "view_work_order_reports",
  VIEW_USERS_REPORTS = "view_users_reports",
  VIEW_FUEL_REPORTS = "view_fuel_reports",
  VIEW_SERVICE_REPORTS = "view_service_reports",
  VIEW_INSPECTION_REPORTS = "view_inspection_reports",
  CREATE_MANAGE_SHAREABLE_REPORTS = "create_manage_shareable_reports",
  FULL_LOCATION_ENTRIES_ACCESS = "full_location_entries_access",
  CREATE_LOCATION_ENTRIES = "create_location_entries",
  EDIT_LOCATION_ENTRIES = "edit_location_entries",
  VIEW_LOCATION_ENTRIES = "view_location_entries",
  VIEW_LOCATION_DETAILS = "view_location_details",
  DELETE_LOCATION_ENTRIES = "delete_location_entries",
  FULL_EXPENSE_ENTRIES_ACCESS = "full_expense_entries_access",
  CREATE_EXPENSE_ENTRIES = "create_expense_entries",
  EDIT_EXPENSE_ENTRIES = "edit_expense_entries",
  VIEW_EXPENSE_ENTRIES = "view_expense_entries",
  DELETE_EXPENSE_ENTRIES = "delete_expense_entries",
  FULL_DASHBOARDS_ACCESS = "full_dashboards_access",
  MANAGE_DASHBOARDS = "manage_dashboards",
  VIEW_DASHBOARD_WIDGETS = "view_dashboard_widgets",
  VIEW_INSPECTION_WIDGETS = "view_inspection_widgets",
  VIEW_SYSTEM_ANALYTICS_DASHBOARDS = "view_system_analytics_dashboards",
  VIEW_VEHICLE_WIDGETS = "view_vehicle_widgets",
  VIEW_REMINDER_WIDGETS = "view_reminder_widgets",
  VIEW_ISSUE_WIDGETS = "view_issue_widgets",
  VIEW_SERVICE_WIDGETS = "view_service_widgets",
  VIEW_COMMENT_WIDGETS = "view_comment_widgets",
  EXPORT_EXPENSE_DATA = "export_expense_data",
  FULL_DOCUMENTS_ACCESS = "full_documents_access",
  MANAGE_FLEET_DOCUMENTS = "manage_fleet_documents",
  VIEW_FLEET_DOCUMENTS = "view_fleet_documents",
  FULL_INTEGRATIONS_ACCESS = "full_integrations_access",
  MANAGE_TELEMATICS_DEVICES = "manage_telematics_devices",
  ARCHIVE_DELETE_TELEMATICS_DEVICES = "archive_delete_telematics_devices",
  ADD_INTEGRATION = "add_integration",
  DELETE_INTEGRATION = "delete_integration",
  VIEW_INTEGRATIONS = "view_integrations",
  UPDATE_INTEGRATION_ITEMS = "update_integration_items",
  FULL_EQUIPMENT_ACCESS = "full_equipment_access",
  VIEW_EQUIPMENT = "view_equipment",
  EXPORT_EQUIPMENT_DATA = "export_equipment_data",
  CREATE_EQUIPMENT = "create_equipment",
  EDIT_EQUIPMENT = "edit_equipment",
  DELETE_EQUIPMENT = "delete_equipment",
  VIEW_EQUIPMENT_ASSIGNMENTS = "view_equipment_assignments",
  MANAGE_EQUIPMENT_ASSIGNMENTS = "manage_equipment_assignments",
  VIEW_EQUIPMENT_RENT = "view_equipment_rent",
  MANAGE_EQUIPMENT_RENT = "manage_equipment_rent",
  VIEW_EQUIPMENT_ATTACHMENTS = "view_equipment_attachments",
  MANAGE_EQUIPMENT_ATTACHMENTS = "manage_equipment_attachments",
}
